import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import moment from 'moment'

// Font Awesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

// utils
import { capitalize } from '../../../utils/text'

// Appt Components
import Box from '../../../components/simple/box/Box'
import DataTable from '../../../components/simple/dataTable/DataTable.js'
import Text from '../../../components/simple/text/Text'

// Services
import FormService from '../../../services/FormService'
import LocalStorageService from '../../../services/LocalStorageService'
import { isServiceAdmin } from '../../../utils/permissions.js'
import Anchor from '../../../components/simple/anchor/Anchor.js'
import ActionButton from '../../../components/compound/actionButton/ActionButton.js'

const IncidentDraftResults = (props) => {
  const apiToken = LocalStorageService.get('apiToken')
  const activeOrg = LocalStorageService.get('activeOrg')
  const terms = LocalStorageService.get('terms')

  const [submissions, setSubmissions] = useState([])
  const [responses, setResponses] = useState([])

  const navigate = useNavigate()

  const deleteReport = async (submissionId) => {
    if (window.confirm('Are you sure you want to delete this?')) {
      await FormService.updateSubmission(apiToken, submissionId, { status: 'Archived' })
      window.location.reload() // this is not ideal
    }
  }

  const resultColumns = [
    // {
    //   property: 'id',
    //   header: <Text>Draft ID</Text>,
    //   render: datum => (
    //     <Text>{datum.id}</Text>
    //   )
    // },
         {
      property: 'Type',
      header: <Text>Type</Text>,
      render: datum => (
        <Anchor href={`/incident/${datum.subType === 'highlevel' ? 'high-level/' : '' }${datum.user}/edit/${datum.id}/draft`} color='primary'>
          <Text>{datum.subType === 'highlevel' ? 'Physical Intervention Report' : 'Incident Report'}</Text>
        </Anchor>
      )
    },
    {
      property: 'createdAt',
      header: <Text>Created</Text>,
      render: datum => (
        <Text>{moment(datum.createdAt).fromNow()}</Text>
      )
    },

    {
      property: 'firstName',
      header: <Text>{capitalize(terms?.serviceUser || 'Service User')}</Text>,
      render: datum => (
        <Anchor href={`/serviceuser/${datum.user}/edit`} color='primary'>
          <Text>{`${datum.firstname || ''} ${datum.lastname || ''}`}</Text>
        </Anchor>
      )
    },
    {
      property: 'location',
      header: <Text>Location</Text>,
      render: datum => (
        <Text>{`${datum.location || ''}`}</Text>
      )
    },
  {
      property: 'description',
      header: <Text>Description</Text>,
      render: datum => (
        <Text>{`${datum.incidentDescription || ''}`}</Text>
      )
    },
    {
      property: 'actions',
      header: <Text>Edit</Text>,
      render: datum => (
        <>
          <Box direction='row' width='100%'>

            <ActionButton
              onClick={() => { navigate(`/incident/${datum.subType === 'highlevel' ? 'high-level/' : '' }${datum.user}/edit/${datum.id}/draft`) }}
              target='_self'
              plain
              children={
                <Box pad='5px'>
                  <FontAwesomeIcon icon={['fal', 'edit']} color='#ff8300' />
                </Box>
              }
            />

            {isServiceAdmin() && <ActionButton
              onClick={() => { deleteReport(datum.id) }}
              target='_self'
              plain
              children={
                <Box pad='5px'>
                  <FontAwesomeIcon icon={['fal', 'trash']} color='#ff8300' />
                </Box>
              }
            />}
          </Box>
        </>
      )
    }
  ]

  return (
    <>
      <DataTable
        columns={resultColumns}
        data={props.results}
        primaryKey='id'
        // sort={sort}
        // onSort={setSort}
      />
      {!props.results.length && <Text>There are no results to display.</Text>}
    </>
  )
}

export default IncidentDraftResults
